import axios from "axios";
import { BASE_URL, instance } from "./interceptors";


export const loginUnit = async (credentials) => {
    try {
      const response = await axios.post(`${BASE_URL}api/token/`, credentials);
      return response.data;
    } catch (error) {
      throw error;
    }
};


export const checkTokenUnit = async () => {
    const token = JSON.parse(localStorage.getItem('persist:auth'))?.token    
    let response = await instance.post(`${BASE_URL}api/token/verify/`,{token: token.replaceAll('"','')})
    return response
} 
